import { Component, OnInit } from '@angular/core';
import { UserService, User, FormSessionCanDeactivate } from '../../shared';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../shared/config/app-config';

@Component({
  selector: 'app-delpat',
  templateUrl: './delpat.component.html',
  styleUrls: ['./delpat.component.css']
})
export class DelpatComponent extends FormSessionCanDeactivate {
  resp:any;
  currentUser: User; 
  public apiurl:any = environment.api_url;
  public parenetshow:boolean=false;
  constructor(
    private userService:UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        
      }
    )
    if(this.route.snapshot.url[0].path == 'deletepat'){
      this.currentUser.operationMessage = ''
    }
    this.userService
    .postuserinfoid('1',this.currentUser.item.userAccountId)
    .subscribe(
      data => {
        this.resp = data; 
        // ////console.log(this.resp);
      }
    );
  }
  setdata(workflow){
    this.userService.setUser(workflow);
   
    
  
  }

}
